import { useNavigate } from 'react-router-dom';
import api from '../../api/CallAdminApi';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import UnsavedReportAlertModal from './UnsavedReportAlertModal';
import CommonHeader, { HeaderMenuItem } from './CommonHeader';
import useHeaderNavigationGuard from './useHeaderNavigationGuard';

const Header = () => {
  const displayName = useSelector((state: RootState) => state.displayName.displayName);
  const { wrapWithNavigationGuard, isDisplayModal, handleCloseModal, handleClickOk } = useHeaderNavigationGuard();
  const navigate = useNavigate();

  const handleClickReportsPageButton = () => navigate('reports');
  const handleClickInstitutionsPageButton = () => navigate('institutions');
  const handleClickInfoPageButton = () => navigate('info');
  const handleClickLogoutButton = async () => {
    await api.Logout();
    navigate('login');
  };

  const menuItems: HeaderMenuItem[] = [
    {
      key: 'reports',
      label: '利用報告一覧',
      onClick: () => wrapWithNavigationGuard(handleClickReportsPageButton),
    },
    {
      key: 'institutions',
      label: '教育機関管理',
      onClick: () => wrapWithNavigationGuard(handleClickInstitutionsPageButton),
    },
  ];

  return (
    <>
      <CommonHeader
        displayLines={[`${displayName}様`]}
        menuItems={menuItems}
        onClickLogo={() => wrapWithNavigationGuard(handleClickReportsPageButton)}
        onClickInfo={() => wrapWithNavigationGuard(handleClickInfoPageButton)}
        onClickLogout={() => wrapWithNavigationGuard(handleClickLogoutButton)}
      />
      <UnsavedReportAlertModal isDisplayModal={isDisplayModal} handleCloseModal={handleCloseModal} handleClickOk={handleClickOk} />
    </>
  );
};

export default Header;
